import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GetCartItems, RemoveItemFromCart } from "../Data";
import { Global } from "../Variables/Global";
import { BsTrash } from "react-icons/bs";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import "./Cart.css";

const CartAr = () => {
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [delivery] = useState(30);

  const token = Cookies.get("CustomerToken");
  const navigate = useNavigate();

  const GetItemsCart = () => {
    const CartId = Cookies.get("Cart");
    if (!CartId) return;

    const groupId = Cookies.get("WishList") ? 4 : 3;

    GetCartItems(CartId, groupId, token).then(result => {
      setCartItems(result.CartItems || []);
      setCartCount(result.Count || 0);
    });
  };

  const getItemPrice = item =>
    item.SalePrice > 0 ? item.SalePrice : item.RegularPrice;

  const getSubtotal = item =>
    getItemPrice(item) * item.Quantity;

  const getTotal = () =>
    cartItems.reduce((sum, i) => sum + getSubtotal(i), 0);

  const HandleRemove = ProductVariationId => {
    const CartId = Cookies.get("Cart");

    RemoveItemFromCart(ProductVariationId, CartId, token)
      .then(r => {
        if (!r.ok) throw new Error();
        toast.success("تمت إزالة المنتج");
        GetItemsCart();
      })
      .catch(() => toast.error("فشل الحذف"));
  };

  useEffect(() => {
    if (!token) navigate("/AR/Authentication");
    GetItemsCart();
  }, []);

  return (
    <>
      {/* Breadcrumb */}
      <nav className="breadcrumb-wrapper rtl">
        <div className="container">
          <ol className="breadcrumb-list">
            <li className="breadcrumb-item">
              <Link to="/AR" className="breadcrumb-link">
                <i className="fa fa-home"></i>
                <span>المنزل</span>
              </Link>
            </li>
            <li className="breadcrumb-separator">/</li>
            <li className="breadcrumb-item active">
              السلة
            </li>
          </ol>
        </div>
      </nav>

      <div className="container cart-page rtl">
        <div className="cart-table-wrapper">
          <table className="cart-table">
            <thead>
              <tr>
                <th>المنتج</th>
                <th>التفاصيل</th>
                <th>السعر</th>
                <th>الكمية</th>
                <th>المجموع</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {cartItems.map((item, index) => {
                const image = item.Image
                  ? Global.PHOTO_URL + item.Image
                  : "/assets/images/placeholder.png";

                return (
                  <tr key={index}>
                    <td className="product-image">
                      <img src={image} alt={item.ProductNameAR} />
                    </td>

                    <td className="product-info">
                      <h4>{item.ProductNameAR}</h4>

                      {item.assignedAttributes?.length > 0 && (
                        <ul className="attributes">
                          {item.assignedAttributes.map((a, i) => (
                            <li key={i}>
                              <strong>{a.AttributeName}:</strong>{" "}
                              {a.AttributeValueName}
                            </li>
                          ))}
                        </ul>
                      )}

                      <small>SKU: {item.Sku}</small>
                    </td>

                    <td className="price">
                      {item.SalePrice > 0 ? (
                        <>
                          <span className="sale">
                            AED {item.SalePrice}
                          </span>
                          <span className="regular">
                            AED {item.RegularPrice}
                          </span>
                        </>
                      ) : (
                        <span>AED {item.RegularPrice}</span>
                      )}
                    </td>

                    <td>{item.Quantity}</td>

                    <td className="subtotal">
                      AED {getSubtotal(item)}
                    </td>

                    <td>
                      <button
                        className="remove-btn"
                        onClick={() =>
                          HandleRemove(item.ProductVariationId)
                        }
                      >
                        <BsTrash />
                      </button>
                    </td>
                  </tr>
                );
              })}

              {cartItems.length === 0 && (
                <tr>
                  <td colSpan="6" className="empty-cart">
                    السلة فارغة
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* ✅ SAME SUMMARY PLACE */}
          <div className="cart-summary">
            <h3>ملخص الطلب</h3>

            <div className="summary-row">
              <span>المجموع</span>
              <span>AED {getTotal()}</span>
            </div>

            <div className="summary-row">
              <span>التوصيل</span>
              <span>AED {delivery}</span>
            </div>

            <div className="summary-row total">
              <span>الإجمالي</span>
              <span>AED {getTotal() + delivery}</span>
            </div>

            <Link
              to="/AR/Checkout"
              state={{ cartItems, cartCount }}
            >
              <button className="checkout-btn">
                إتمام الدفع
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default CartAr;
